import React, { useState } from 'react';
import { Gauge, RotateCcw } from 'lucide-react';
import useSpeedTest, { DEFAULT_SIZE_BYTES } from '../../hooks/useSpeedTest';
import SpeedTestGauge from '../../components/common/SpeedTestGauge';
import SpeedTestStats from '../../components/common/SpeedTestStats';
import SpeedTestSizePicker from '../../components/common/SpeedTestSizePicker';

export default function CustomerSpeedTest() {
  const {
    phase, ping, jitter, downloadMbps, uploadMbps, liveMbps,
    downloadPingIncrease, uploadPingIncrease, error, run, cancel,
  } = useSpeedTest();
  const [size, setSize] = useState(DEFAULT_SIZE_BYTES);
  const running = phase === 'ping' || phase === 'download' || phase === 'upload';

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700 }}>Speed Test</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '.85rem' }}>Check your connection's ping, download, and upload speed</p>
      </div>

      <div className="card" style={{ padding: '28px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 22 }}>
        <SpeedTestGauge phase={phase} liveMbps={liveMbps} />

        <SpeedTestSizePicker value={size} onChange={setSize} disabled={running} />

        {phase !== 'idle' && phase !== 'error' && (
          <SpeedTestStats
            ping={ping} downloadMbps={downloadMbps} uploadMbps={uploadMbps}
            downloadPingIncrease={downloadPingIncrease} uploadPingIncrease={uploadPingIncrease}
          />
        )}
        {phase === 'done' && jitter != null && (
          <p style={{ fontSize: '.72rem', color: 'var(--text-muted)', margin: 0 }}>Jitter: {jitter} ms</p>
        )}
        {error && <p style={{ color: '#dc2626', fontSize: '.85rem', margin: 0 }}>{error}</p>}

        <button
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center' }}
          onClick={running ? cancel : () => run(size)}
        >
          {running ? 'Cancel' : (
            <>
              {phase === 'done' || phase === 'error' ? <RotateCcw size={15} /> : <Gauge size={15} />}
              {phase === 'done' || phase === 'error' ? 'Test Again' : 'Start Test'}
            </>
          )}
        </button>
      </div>
    </div>
  );
}
